/**
 * 设备类型判断
 * 通过 UserAgent 识别移动端（含手机/平板）
 */
export const isMobile = () => {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
    navigator.userAgent
  )
}

export const isPC = () => !isMobile()
